import "./i18n";
import "react-toastify/dist/ReactToastify.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./index.scss";

import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";

import App from "./App";
import { store } from "./app/store";
import Fallback from "./components/Fallback";
import { ThemeProvider } from "./context/ThemeContext";
import { CustomBrowserRouter } from "./helpers/CustomerBrowserRouter";
import Modals from "./modals";
import reportWebVitals from "./reportWebVitals";

const container = document.getElementById("root")!;
const root = createRoot(container);

root.render(
  // StrictMode временно отключен для совместимости с react-beautiful-dnd
  // <React.StrictMode>
  <Provider store={store}>
    <ThemeProvider>
      <CustomBrowserRouter>
        <React.Suspense fallback={<Fallback />}>
          <App />
          <Modals />
        </React.Suspense>
        <ToastContainer theme="dark" />
      </CustomBrowserRouter>
    </ThemeProvider>
  </Provider>
  // </React.StrictMode>
);

// Register DICOM service worker (transparent cache for WADO/SEG)
if ("serviceWorker" in navigator) {
  try {
    navigator.serviceWorker.register("/dicom-sw.js");
  } catch {}
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
